import { API_BASE_URL } from '../config';

const baseUrl= API_BASE_URL;
export const getSpacesByFilters = async ({
  text,
  lat,
  lng,
  lat_p1,
  lat_p2,
  lng_p1,
  lng_p2,
  city,
  country,
  lang,
  page,
  perPage,
  postal_code,
  from,
  to,
  capacity,
  style,
  min_price,
  max_price,
  instant_booking,
  with_locks,
  type,
  order,
  order_type,
  order_price_type = "",
  usages = [],
  price_type = "",
  options = {},
  token = null,
  member_plus,
} = {}) => {
  const params = [];

  // Append only if values are present
  if (city) params.push(`city=${encodeURIComponent(city)}`);
  if (country) params.push(`country=${encodeURIComponent(country)}`);
  if (lat) params.push(`lat=${lat.toString()}`);
  if (lng) params.push(`lng=${lng.toString()}`);
  if (lat_p1) params.push(`lat_p1=${lat_p1.toString()}`);
  if (lat_p2) params.push(`lat_p2=${lat_p2.toString()}`);
  if (lng_p1) params.push(`lng_p1=${lng_p1.toString()}`);
  if (lng_p2) params.push(`lng_p2=${lng_p2.toString()}`);
  if (text) params.push(`text=${encodeURIComponent(text)}`);
  if (lang) params.push(`lang=${lang === "uk" ? "en" : lang}`);
  if (page) params.push(`page=${page.toString()}`);
  if (perPage) params.push(`perPage=${perPage.toString()}`);
  if (from) params.push(`from=${encodeURIComponent(from)}`);
  if (to) params.push(`to=${encodeURIComponent(to)}`);
  if (capacity) params.push(`capacity=${capacity.toString()}`);
  if (style) params.push(`place_style_id=${style.toString()}`);
  if (min_price) params.push(`min_price=${min_price.toString()}`);
  if (max_price) params.push(`max_price=${max_price.toString()}`);
  if (price_type) params.push(`price_type=${encodeURIComponent(price_type)}`);
  if (instant_booking) params.push(`instant_booking=true`);
  if (with_locks) params.push("with-locks"); // No equals sign!
  if (type) params.push(`type=${encodeURIComponent(type)}`);
  if (order) params.push(`order=${encodeURIComponent(order)}`);
  if (order_type) params.push(`order_type=${encodeURIComponent(order_type)}`);
  if (order_price_type) params.push(`order_price_type=${encodeURIComponent(order_price_type)}`);
  if (postal_code) params.push(`postal_code=${postal_code.toString()}`);
  if (member_plus) params.push(`member_plus=${encodeURIComponent(member_plus)}`);

  // Handle usages array
  const filteredUsages = usages.filter(usage => usage !== "");
  if (filteredUsages.length > 0) {
    filteredUsages.forEach((usage) => params.push(`usages[]=${encodeURIComponent(usage)}`));
  }

  // Transform and append `options`
  if (Object.keys(options).length > 0) {
    const defaultOptions = {
      parkings: [],
      placeTypes: [],
      meals: [],
      openingHours: [],
      characteristics: [],
      layouts: [],
    };

    const mergedOptions = { ...defaultOptions, ...options };
    const optionsString = JSON.stringify(mergedOptions);
    params.push(`options=${encodeURIComponent(optionsString)}`);
  }

  // Construct the URL
  const url = `${API_BASE_URL}places?${params.join('&')}`;

  const headers = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
      cache: 'no-store'
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();

    if (!data || !data.data) {
      throw new Error("Invalid response structure");
    }

    return data;
  } catch (error) {
    console.error("Error fetching places:", error.message);
    throw error;
  }
};

export const getNearbyPlaces = async ({
  lat,
  lng,
  place_id,
  lang,
  type,
  radius,
  min_price,
  max_price,
  usage = "",
} = {}) => {
  const queryParams = new URLSearchParams();

  // Required parameters
  // if (!lat || !lng) {
  //   throw new Error("Latitude and Longitude are required.");
  // }

  if (lat) queryParams.append("lat", lat.toString());
  if (lng) queryParams.append("lng", lng.toString());
  if (radius) queryParams.append("radius", radius.toString());
  if (type) queryParams.append("type", type);
  if (lang) queryParams.append("lang", lang === "uk" ? "en" : lang);
  if (min_price) queryParams.append("min_price", min_price.toString());
  if (max_price) queryParams.append("max_price", max_price.toString());
  if (place_id) queryParams.append("place_id", place_id.toString());
  if (usage) queryParams.append("usage", usage.toString());

  const url = `${API_BASE_URL}places/nearby-places?${queryParams.toString()}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();

    if (!data || !data.data) {
      throw new Error("Invalid response structure");
    }

    return data.data;
  } catch (error) {
    console.error("Error fetching nearby places:", error.message);
    throw error;
  }
};
